<template>
  <div :class="sidebarClasses" :data-background-color="backgroundColor" :data-font-color="fontColor"
    :data-active-color="activeColor">
    <div v-if="$store.state.isQCAS" class="logo logo-large">
      <div class="logo-img-large">
        <img src="static/img/qcas/QCAS_Ecctis_logo.jpg" class="logo-img-large" />
      </div>
    </div>
    <div v-else>
      <div class="logo logo-large" style="height: 75px !important; padding: 5px;">
        <div class="logo-img-large" style="height: auto;">
          <img src="static/img/qc/QC-Logo-2.png" class="logo-img-large" style="height: 65px;" />
        </div>
      </div>
      <div v-if="$store.state.partnerLogo" style="position: relative; z-index: 4; text-align: center">
        <span style="color: white">In partnership with</span>
        <br />
        <img style="max-height: 50px; max-width: 80%" :src="$store.state.partnerLogo" />
      </div>
      <div v-if="$store.state.ownerLogo" style="position: relative; z-index: 4; text-align: center">
        <span style="color: white">On behalf of</span>
        <br />
        <img style="max-height: 50px; max-width: 80%" :src="$store.state.ownerLogo" />
      </div>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot> </slot>
      <ul :class="navClasses">
        <slot name="links">
          <sidebar-item v-if="!(
            ($store.state.paymentType == 'INSTITUTE' || $store.state.paymentType.endsWith('_PARENT')) &&
            $store.getters.allowedTypes.length < 1
          )
            " v-for="(link, index) in dashboardLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
            </sidebar-item>
          </sidebar-item>
          <sidebar-item v-if="$store.state.paymentType != 'NONE' &&
            $store.getters.allowedTypes.length > 0
            " v-for="(link, index) in verificationLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
            </sidebar-item>
          </sidebar-item>
          <!--
          <sidebar-item v-if="$store.state.isIndividual" v-for="(link, index) in applicationLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
            </sidebar-item>
          </sidebar-item>
          -->
          <sidebar-item v-if="$store.state.hasReferrals" v-for="(link, index) in referralOwnerLinks"
            :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
            </sidebar-item>
          </sidebar-item>
          <sidebar-item v-if="$store.state.paymentType == 'INSTITUTE' || $store.state.paymentType.endsWith('_PARENT')" v-for="(link, index) in instituteLinks"
            :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
            </sidebar-item>
          </sidebar-item>
          <sidebar-item v-if="$store.state.paymentType == 'INSTITUTE'" v-for="(link, index) in fullInstituteLinks"
            :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
            </sidebar-item>
          </sidebar-item>
          <sidebar-item v-if="$store.state.hasApplicants" v-for="(link, index) in applicantLinks" :key="link.name + index"
            :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
            </sidebar-item>
          </sidebar-item>
          <sidebar-item v-if="$store.getters.usesTokens &&
            $store.getters.allowedTypes.length > 0
            " v-for="(link, index) in tokenLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
            </sidebar-item>
          </sidebar-item>
          <sidebar-item v-if="$store.state.paymentType == 'CARD' &&
            $store.getters.allowedTypes.length > 0
            " v-for="(link, index) in creditLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
            </sidebar-item>
          </sidebar-item>
          <sidebar-item v-for="(link, index) in userLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "Paper Dashboard Pro",
    },
    type: {
      type: String,
      default: "sidebar",
      validator: (value) => {
        let acceptedValues = ["sidebar", "navbar"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundColor: {
      type: String,
      default: "white",
      validator: (value) => {
        let acceptedValues = [
          "white",
          "primary",
          "default",
          "brown",
          "black",
          "darkblue",
          "gradient-purple",
          "gradient-darkblue",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    fontColor: {
      type: String,
      default: "font",
      validator: (value) => {
        let acceptedValues = ["primary", "default", "font", "white"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "default",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: "static/img/qc/QC-Logo-2.png",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      applicationLinks: [
        {
          name: "Applications",
          icon: "ti-clipboard",
          path: "/application/history",
        },
      ],
      applicantLinks: [
        {
          name: "Applicants",
          icon: "ti-clipboard",
          path: "/applicant/history",
        },
      ],
      referralOwnerLinks: [
        {
          name: "Referrals",
          icon: "ti-clipboard",
          path: "/referrals/list",
        },
      ],
      instituteLinks: [
        {
          name: "Pending Verifications",
          icon: "ti-view-list-alt",
          path: "/verification/pending",
        },
        {
          name: "Resolved Verifications",
          icon: "ti-layout-list-thumb",
          path: "/verification/resolved",
        }
      ],
      fullInstituteLinks: [
      ],
      tokenLinks: [
        {
          name: "Order Credits",
          icon: "fa fa-plus-circle",
          path: "/credit/order",
        },
      ],
      // clientMILinks: [
      //   {
      //     name: "Country Insights",
      //     icon: "fa fa-globe",
      //     path: "/countryinfo",
      //   },
      // ]
    };
  },
  computed: {
    dashboardLinks() {
      const links = []
      if (!this.$store.state.isIndividual) {
        links.push({
          name: "Home",
          icon: "ti-home",
          path: "/home",
        });
      }
      if (!this.$store.state.isApplicant || this.$store.state.openApplications == 0) {
        if (this.$store.state.isIndividual) {
          links.push({
            name: "I'm Verified Wallet",
            icon: "qc2-wab",
            path: "/wallet",
          });
        } else {
          links.push({
            name: "Dashboard",
            icon: "ti-panel",
            path: "/dashboard",
          });
        }
      }
      return links;
    },
    verificationLinks() {
      var links = [];
      if (!this.$store.state.isApplicant || this.$store.state.openApplications == 0)
        if (!this.$store.state.sharingDisabled) {
          links.push({
            name: "New Verification",
            icon: "ti-plus",
            path: "/verification/new",
          });
        }
      {
        // links.push({
        //     name: "Country Insights",
        //     icon: "fa fa-globe",
        //     path: "/countryinfo",
        // })
      }
      // if (!this.$store.state.isIndividual) {
      // if (this.$store.getters.allowed("edu")) {
      // links.push({
      //   name: "Coverage",
      //   icon: "ti-world",
      //   path: "/verification/coverage",
      // });
      // }
      // }
      if (!this.$store.state.isIndividual) {
        links.push({
          name: "Verification History",
          icon: "ti-layers-alt",
          path: "/verification/history",
        });
      }
      if (this.$store.state.isApplicant && this.$store.state.openApplications > 0) {
        links.push({
          name: "Open Applications",
          icon: "fa fa-check-square-o",
          path: "/applications/open",
        });
      }
      return links;
    },
    creditLinks() {
      var links = [];
      if (!this.$store.state.isIndividual) {
        links.push({
          name: "Buy Credit",
          icon: "ti-credit-card",
          path: "/credit/buy",
        });
      }
      links.push({
        name: this.$store.state.isIndividual ? "Receipts" : "Invoices",
        icon: "ti-list",
        path: "/credit/history",
      });

      return links;
    },
    userLinks() {
      var links = []
      if (!this.$store.state.isIndividual && this.$store.state.hasAnalyticsAccess && this.$store.state.admin) {
        links.push({
          name: `Analytics`,
          icon: 'ti-bar-chart-alt',
          path: '/analytics'
        })
      }
      if (!this.$store.state.isIndividual) {
        links.push({
          name: "Country Insights",
          icon: "fa fa-globe",
          path: "/countryinfo",
        });
      }
      links.push({
        name: "Account",
        icon: "fa fa-user",
        path: "/account",
      });
      links.push({
        name: "FAQS",
        icon: "fa fa-question-circle",
        path: "/faqs"
      })
      links.push({
        name: "Logout",
        icon: "fa fa-sign-out",
        action: "logout",
      });
      return links
    },
    sidebarClasses() {
      if (this.type === "sidebar") {
        return "sidebar";
      } else {
        return "collapse navbar-collapse off-canvas-sidebar";
      }
    },
    navClasses() {
      if (this.type === "sidebar") {
        return "nav";
      } else {
        return "nav navbar-nav";
      }
    },
  },
  methods: {
    async initScrollBarAsync() {
      await import("perfect-scrollbar/dist/css/perfect-scrollbar.css");
      const PerfectScroll = await import("perfect-scrollbar");
      PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    },
  },
  mounted() {
    this.initScrollBarAsync();
    this.$store.commit("updateMeta");
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
@media (min-width: 992px) {

  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
